import { render, staticRenderFns } from "./DefaultLabel.vue?vue&type=template&id=2b69f614"
import script from "./DefaultLabel.vue?vue&type=script&lang=ts"
export * from "./DefaultLabel.vue?vue&type=script&lang=ts"
import style0 from "./DefaultLabel.vue?vue&type=style&index=0&id=2b69f614&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b69f614')) {
      api.createRecord('2b69f614', component.options)
    } else {
      api.reload('2b69f614', component.options)
    }
    module.hot.accept("./DefaultLabel.vue?vue&type=template&id=2b69f614", function () {
      api.rerender('2b69f614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Labels/DefaultLabel.vue"
export default component.exports